export const iconFontAwesomeGamingFantasyFlightGames = (
	<i className="fa-solid fa-fantasy-flight-games"></i>
);
